/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const CircleSlash2 = [
  ["circle", { cx: "12", cy: "12", r: "10" }],
  ["path", { d: "M22 2 2 22" }]
];

export { CircleSlash2 as default };
//# sourceMappingURL=circle-slash-2.js.map
